import PropTypes from 'prop-types';
import React from 'react';
import { useUpdateEffect } from 'react-use';
import PropertyCard from 'components/PropertyCard';
import { useHover } from 'hooks/useHover';
import { Box } from 'roo-ui/components';

const Result = ({ property, onHover, onClick }) => {
  const { id: propertyId, latitude: lat, longitude: lng } = property;
  const [isHovered, hoverEventHandlers] = useHover();

  useUpdateEffect(() => {
    const hoveredPropertyId = isHovered ? propertyId : null;

    onHover({
      id: hoveredPropertyId,
      lat,
      lng,
    });
  }, [isHovered]);

  return (
    <Box {...hoverEventHandlers} mb={4} mx={4}>
      <PropertyCard {...property} onClick={onClick} inline openPropertyInNewTab />
    </Box>
  );
};

Result.propTypes = {
  property: PropTypes.object.isRequired,
  onHover: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

Result.defaultProps = {
  onClick: undefined,
};

export default Result;
